import Endpoints from '@/constants/endpoints';
import $http from '@/core/services/http.service';

export class SyncService {
    public static importCsv(file: any) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file);
            $http.post(`${Endpoints.syncFile}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                },
            )
            .then((res) => {
                resolve(res.data);
            }).catch((err) => {
                reject(err);
            });
        });

    }
}
